import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  productFileAttached: false,
  categoryFileAttached: false,
};

const fileSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    setProductFileAttached: (state, action) => {
      state.productFileAttached = action.payload;
    },
    setCategoryFileAttached: (state, action) => {
      state.categoryFileAttached = action.payload;
    },
  },
});

export const { setProductFileAttached, setCategoryFileAttached } = fileSlice.actions;
export default fileSlice.reducer;
